var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Exit",
    clipPath: "url(#clip0_5865_15590)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.7068 0.29297C23.5193 0.105499 23.2649 0.000183105 22.9998 0.000183105C22.7346 0.000183105 22.4803 0.105499 22.2928 0.29297L11.9998 10.586L1.70679 0.29297C1.51926 0.105499 1.26495 0.000183105 0.999786 0.000183105C0.734622 0.000183105 0.480314 0.105499 0.292786 0.29297C0.105315 0.480497 0 0.734805 0 0.99997C0 1.26513 0.105315 1.51944 0.292786 1.70697L10.5858 12L0.292786 22.293C0.105315 22.4805 0 22.7348 0 23C0 23.2651 0.105315 23.5194 0.292786 23.707C0.480314 23.8944 0.734622 23.9998 0.999786 23.9998C1.26495 23.9998 1.51926 23.8944 1.70679 23.707L11.9998 13.414L22.2928 23.707C22.4803 23.8944 22.7346 23.9998 22.9998 23.9998C23.2649 23.9998 23.5193 23.8944 23.7068 23.707C23.8943 23.5194 23.9996 23.2651 23.9996 23C23.9996 22.7348 23.8943 22.4805 23.7068 22.293L13.4138 12L23.7068 1.70697C23.8943 1.51944 23.9996 1.26513 23.9996 0.99997C23.9996 0.734805 23.8943 0.480497 23.7068 0.29297Z",
    fill: "#1A1B22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5865_15590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/Exit.f8f5bedf2d452414240b07e2d376da74.svg";
export { ForwardRef as ReactComponent };